import React, { useState } from 'react';
import './HostelCard.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FoodSupplierDetails from '../FoodSupplier/FoodSupplierDetails';

const FoodSupplierCard = ({ image, name, city }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className='hotel-card'>
      <img src={image} alt={name} />
      <div className='card-content'>
        <h3>{name}</h3>
        <p>{city}</p>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleClickOpen}
          sx={{ fontSize: '12px' }}  // Reduced font size
        >
          Details
        </Button>
        <Button 
          onClick={() => alert('Schedule Visit button clicked!')} 
          variant="outlined" 
          color="primary"
          sx={{ fontSize: '12px' }}  // Reduced font size
        >
          Schedule Visit
        </Button>
        <Button 
          onClick={() => alert('Request Call Back button clicked!')} 
          variant="outlined" 
          color="primary"
          sx={{ fontSize: '12px' }}  // Reduced font size
        >
          Request Call Back
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            {name} - {city}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <FoodSupplierDetails name={name} city={city} image={image} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="contained" color="secondary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default FoodSupplierCard;
